export default {
	install: (Vue, options) => {
		Vue.prototype.$service = options.moduleService;
		// Vue.config.globalProperties.$service = options.moduleService; // for VUE 3
	},
};
